import * as React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  LINE_PERIOD_FILTER_DEFAULT,
  LINE_PERIOD_FILTER_LABELS,
  LINE_PERIOD_QP_KEY,
  parsePeriodFilter,
  type LinePeriodFilter,
} from "@/types/period-filter.types";

const PRESET_ORDER: LinePeriodFilter[] = ["active", "24h", "7d", "30d"];

interface Props {
  value?: LinePeriodFilter;
  onChange?: (next: LinePeriodFilter) => void;
  className?: string;
}

export function useLinePeriodFilter(): [LinePeriodFilter, (next: LinePeriodFilter) => void] {
  const [search, setSearch] = useSearchParams();
  const value = parsePeriodFilter(search.get(LINE_PERIOD_QP_KEY));

  const setValue = React.useCallback(
    (next: LinePeriodFilter) => {
      const params = new URLSearchParams(search);
      if (next === LINE_PERIOD_FILTER_DEFAULT) {
        params.delete(LINE_PERIOD_QP_KEY);
      } else {
        params.set(LINE_PERIOD_QP_KEY, next);
      }
      setSearch(params, { replace: true });
    },
    [search, setSearch]
  );

  return [value, setValue];
}

export function LineKPIStripPeriodFilter({
  value: valueProp,
  onChange,
  className,
}: Props): React.ReactElement {
  const [internalValue, internalSet] = useLinePeriodFilter();
  const value = valueProp ?? internalValue;
  const setValue = onChange ?? internalSet;

  return (
    <Tabs value={value} onValueChange={(next) => setValue(next as LinePeriodFilter)}>
      <TabsList variant="pill" aria-label="Período exibido nos indicadores" className={className}>
        {PRESET_ORDER.map((preset) => (
          <TabsTrigger key={preset} value={preset}>
            {LINE_PERIOD_FILTER_LABELS[preset]}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
